import React from "react";
import { Button } from "antd";

function ButtonComponent({ children, type, ...rest }) {
  return (
    <Button type={type} {...rest}>
      {children}
    </Button>
  );
}

export default ButtonComponent;
